module.exports = __webpack_public_path__ + "img/20180815_150119_053.4b888866.jpg";